
import { computed, defineComponent } from "vue";
import { useStore } from "vuex";

export default defineComponent({
  name: "base-header",
  setup() {
    const store = useStore();
    const IsLoggedIn = computed(() => store.getters["userState/getIsLoggedIn"]);
    const nickname = computed(() => store.getters["userState/getNickname"]);
    const logout = () => store.commit("userState/initData");

    return {
      IsLoggedIn,
      nickname,
      logout,
    };
  },
  methods: {
    logoutHandler() {
      this.logout();
    },
    homeClickHandler() {
      this.$router.push("/");
    },
  },
});
